import request from '@/utils/request'

const baseUrl = '/report'

export interface Template {
  id: number
  createdAt: Date
  updatedAt: Date
  name: string
  timeGroup: string
  monthlyReport: boolean
  dataDuration: string
  timeFormat: string
  fieldTime1Format: string
  fieldTime2Format: string
  filename: string
  sheetname: string
  extension: string
  fileSize: number
  query: string
  // eslint-disable-next-line
  dataMap: any
  default: boolean
}

export interface TemplateFile {
  filename: string
  extension: string
  fileSize: number
  blob: Uint8Array[]
}

export function CreateTemplate(t: Template, f: File) {
  const formData = new FormData()
  formData.append('name', t.name)
  formData.append('query', t.query)
  formData.append('timeGroup', t.timeGroup)
  formData.append('monthlyReport', t.monthlyReport ? 'yes' : 'no')
  formData.append('dataDuration', t.dataDuration)
  formData.append('timeFormat', t.timeFormat)
  formData.append('fieldTime1Format', t.fieldTime1Format)
  formData.append('fieldTime2Format', t.fieldTime2Format)
  formData.append('sheetname', t.sheetname)

  formData.append('file', f)

  return request.post(`${baseUrl}/template`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export function DuplicateTemplate(
  srcId: number,
  name: string
): Promise<Template> {
  return request.post(`${baseUrl}/template/${srcId}`, { name })
}

export function FindTemplates(): Promise<Template[]> {
  return request.get(`${baseUrl}/template`)
}

export function GetTemplate(id: number): Promise<Template> {
  return request.get(`${baseUrl}/template/${id}`)
}

export function PatchTemplate(
  id: number,
  t: Template,
  f: File,
  sheetname: string
) {
  const formData = new FormData()
  formData.append('name', t.name)
  formData.append('query', t.query)
  formData.append('timeGroup', t.timeGroup)
  formData.append('monthlyReport', t.monthlyReport ? 'yes' : 'no')
  formData.append('dataDuration', t.dataDuration)
  formData.append('timeFormat', t.timeFormat)
  formData.append('fieldTime1Format', t.fieldTime1Format)
  formData.append('fieldTime2Format', t.fieldTime2Format)
  formData.append('sheetname', sheetname)
  formData.append('file', f)

  return request.patch(`${baseUrl}/template/${id}`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export function DeleteTemplate(id: number) {
  return request.delete(`${baseUrl}/template/${id}`)
}

export function DownloadTemplate(id: number) {
  return request.get(`${baseUrl}/template/download/${id}`, {
    responseType: 'blob',
  })
}
